import Vue from 'vue';
import Vuex from 'vuex';
import client from '@/services/axios';
import createPersistedState from 'vuex-persistedstate';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let token = null;
let eventId = null;
let error = null;
if (urlParams.has('tk')) {
  token = urlParams.get('tk');
  const decoded = JSON.parse(atob(token.split('.')[1]));
  eventId = decoded.eventId;
}
if (urlParams.has('event')) {
  eventId = urlParams.get('event');
}

let initialState = {
  error: error,
  namespace: eventId,
  token: token
};

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: `agmify-${eventId}`,
      storage: window.sessionStorage,
      paths: ['token'],
      filter: (mutation) => mutation.type === 'LOGIN'
    })
  ],
  state: {
    ...initialState,
    user: null,
    event: null,
    history: new Map(),
    poll: [],
    activePoll: null,
    onlineUsers: []
  },
  mutations: {
    LOGIN(state, payload) {
      state.token = payload;
    },
    LOGOUT(state) {
      state.token = '';
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_EVENT(state, payload) {
      state.event = payload;
    },
    SET_HISTORY(state, payload) {
      state.history.set(payload.pollId, payload);
    },
    SET_ACTIVE_POLL(state, payload) {
      state.activePoll = payload;
    },
    SET_POLLS(state, payload) {
      state.polls = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },

    // INCOMING SOCKETS
    SOCKET_POLL_COUNT_CHANGE(state, payload) {
      state.activePoll = payload;
    },
    SOCKET_ONLINEUSERS(state, payload) {
      state.onlineUsers = payload;
    }

    // SOCKET_POLLS_CHANGE(state, payload) {
    //   let index = state.polls.findIndex((item) => item._id === payload._id);
    //   state.polls[index] = payload;
    //   state.polls = [...state.polls];
    // }
  },
  getters: {
    getAnswerValue: (state) => (ids) => {
      // Filter out matching answers
      //console.log('TITLES', ids);
      const findTitles = state.activePoll.answers.filter((answer) =>
        ids.includes(answer._id)
      );
      // map only the titles to an array
      const titles = findTitles.map((answer) => answer.title);

      return titles;
    }
  },
  actions: {
    async getPolls({ state, commit }) {
      const result = await client.get(`/polls/event/${state.event._id}`);
      commit('SET_POLLS', result.data);
    },
    async getHistory({ state, commit }) {
      const response = await client.get('/votes/user/' + state.user._id);
      const history = response.data;
      history.forEach((vote) => {
        commit('SET_HISTORY', vote);
      });
    },
    verifyToken({ state, commit }) {
      const decoded = JSON.parse(atob(state.token.split('.')[1]));
      const eventId = decoded.eventId;
      if (state.namespace !== eventId) {
        commit('LOGOUT');
      }
    },
    async userLogin({ state, commit }) {
      try {
        let response = await client.get('/events/' + state.namespace);
        const event = response.data;
        response = await client.get('/sso/profile');
        const user = response.data;

        commit('SET_USER', user);
        commit('SET_EVENT', event);
      } catch (err) {
        commit('SET_ERROR', err.error);
      }
    }
  },
  modules: {}
});
